// @givmo/employer-module — the module's own constants (EP-MNT3; moved from `apps/admin/src/lib/constants.ts`,
// which re-exports them so its old import path keeps working).

/**
 * The consumer app's store listings, used by the EP-WEB8 announcement template so an admin can tell
 * employees where to get the app.
 *
 * These are the same two URLs `apps/donate/app/components/app-download.tsx` ships (the store listings are
 * the source of truth for both). Each app keeps its own copy rather than importing across an app
 * boundary — the house convention the admin CSV plumbing and the charity app also follow.
 */
export const APP_STORE_URL = 'https://apps.apple.com/app/id6473794314' as const;
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=tech.empat.givmo' as const;
